// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_apiKey ,
  authDomain:process.env.REACT_APP_apiKeyauthDomain ,
  projectId: process.env.REACT_APP_apiKeyprojectId,
  storageBucket:process.env.REACT_APP_apiKeystorageBucket ,
  messagingSenderId:process.env.REACT_APP_apiKeymessagingSenderId ,
  appId:process.env.REACT_APP_apiKeyappId
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


export default app;